/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Grid, Typography2 } from '@coursera/cds-core';

import EmbeddedPartnerV2 from 'bundles/enterprise-learning-path-description-page/components/syllabus/EmbeddedPartnerV2';
import type { EnterpriseCourseFieldsFragment } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/EnterpriseLearningPathPageFragments';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

const styles = {
  title: css`
    margin-bottom: var(--cds-spacing-200);
  `,

  button: css`
    margin-top: var(--cds-spacing-100);
  `,
};

type PartnerFragment = EnterpriseCourseFieldsFragment['partners'][0];

type Props = {
  partners: PartnerFragment[];
};

const BASE_PARTNERS_DISPLAY_COUNT = 6;

const SkillPathwaySidebarContentV2 = ({ partners }: Props) => {
  const [showAllPartners, setShowAllPartners] = React.useState(false);

  if (!partners?.length) {
    return null;
  }

  const embeddedPartnersData = partners;
  const displayedPartners = showAllPartners
    ? embeddedPartnersData
    : embeddedPartnersData.slice(0, BASE_PARTNERS_DISPLAY_COUNT);
  const hasMorePartners = embeddedPartnersData.length > BASE_PARTNERS_DISPLAY_COUNT;

  return (
    <React.Fragment>
      <Typography2 variant="subtitleLarge" component="h3" css={styles.title}>
        {_t('Offered by')}
      </Typography2>
      <Grid container direction="column" spacing={8}>
        {displayedPartners.map((partner: any) => (
          <Grid item key={partner.id}>
            <EmbeddedPartnerV2 partner={partner} />
          </Grid>
        ))}
      </Grid>
      {hasMorePartners && !showAllPartners && (
        <Button variant="ghost" size="small" onClick={() => setShowAllPartners(true)} css={styles.button}>
          <FormattedMessage
            message={_t('Show {count} more')}
            count={embeddedPartnersData.length - BASE_PARTNERS_DISPLAY_COUNT}
          />
        </Button>
      )}
    </React.Fragment>
  );
};

export default SkillPathwaySidebarContentV2;
